import { render, staticRenderFns } from "./UserFrequentJob.vue?vue&type=template&id=0cf2445d&scoped=true&"
import script from "./UserFrequentJob.vue?vue&type=script&lang=ts&"
export * from "./UserFrequentJob.vue?vue&type=script&lang=ts&"
import style0 from "./UserFrequentJob.vue?vue&type=style&index=0&id=0cf2445d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf2445d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VProgressCircular,VTooltip})
